module.exports = __webpack_public_path__ + "img/darwin-s-argument-by-analogy-cover.7f19a26f.jpg";